(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bi-case-video-grid"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const lightboxOptions = {
      touchNavigation: true,
      loop: true,
      autoplayVideos: true,
      youtube: {
        noCookie: true,
        rel: 0,
        showinfo: 0,
        iv_load_policy: 3,
      },
    };
    const lightbox = GLightbox(lightboxOptions);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bi-logo-line"] && !window.DesignMode) return;
  try {
    
  // Add any custom JavaScript here

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bi-what-our-customers-say"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var videoItems = document.querySelectorAll('.tw-video-item');
    videoItems.forEach(function (item) {
      item.addEventListener('click', function (e) {
        var videoUrl = e.currentTarget.getAttribute('data-video-url');
        if (videoUrl) {
          // Assuming a function openLightbox exists to handle the lightbox display
          openLightbox(videoUrl);
        }
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.bio-button').forEach(function (button) {
      button.addEventListener('click', function () {
        var bio = this.getAttribute('data-bio');
        var coursesLink = this.getAttribute('data-courses-link');
        var name = this.getAttribute('data-name');
        var jobTitle = this.getAttribute('data-job-title');
        var linkedinLink = this.getAttribute('data-linkedin-link');
        var imageSrc = this.getAttribute('data-image'); // Updated to use data-image attribute
        var lightboxContent = `
        <div class="lightbox-content tw-max-w-[400px] tw-rounded-xl tw-shadow-xl tw-p-8 tw-max-h-[80vh] tw-overflow-y-auto" style="position: fixed; top: 50%; left: 50%; transform: translate(-50%, -50%); background-color: white; padding: 20px; z-index: 1001;">
          <img class="tw-w-full tw-rounded-xl tw-shadow-xl" src="${imageSrc}" alt="${name}" width="300" height="300">
          <h3 class="tw-mt-8 !tw-font-bold tw-text-4xl">${name}</h3>
          <p>${jobTitle}</p>
          ${linkedinLink ? `<a href="${linkedinLink}" target="_blank">LinkedIn</a>` : ''}
          <div class="tw-py-16">${bio}</div>
          ${
            coursesLink
              ? `<a class="bi-button tw-uppercase tw-font-bold tw-mb-8 tw-text-[#F94FAB]" href="${coursesLink}" target="_blank">View ${name}'s Courses</a>`
              : ''
          }
        </div>`;
        var lightboxWrapper = document.createElement('div');
        lightboxWrapper.className = 'lightbox-wrapper';
        lightboxWrapper.style.position = 'fixed';
        lightboxWrapper.style.top = '0';
        lightboxWrapper.style.left = '0';
        lightboxWrapper.style.width = '100%';
        lightboxWrapper.style.height = '100%';
        lightboxWrapper.style.backgroundColor = 'rgba(0,0,0,0.8)';
        lightboxWrapper.style.zIndex = '1000';
        lightboxWrapper.innerHTML = lightboxContent;
        document.body.appendChild(lightboxWrapper);

        lightboxWrapper.addEventListener('click', function (event) {
          if (event.target === this) {
            lightboxWrapper.remove();
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["latest-videos"] && !window.DesignMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    var videoItems = document.querySelectorAll('.tw-video-item');
    var isDragging = false;

    videoItems.forEach(function (item) {
      item.addEventListener('mousedown', function () {
        isDragging = false;
      });

      item.addEventListener('mousemove', function () {
        isDragging = true;
      });

      item.addEventListener('mouseup', function (e) {
        if (!isDragging) {
          var videoUrl = e.currentTarget.getAttribute('data-video-url');
          if (videoUrl && e.currentTarget.classList.contains('is-selected')) {
            // Assuming a function openLightbox exists to handle the lightbox display
            openLightbox(videoUrl);
          }
        }
      });

      item.addEventListener('click', function (e) {
        e.preventDefault();
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
